import React, { Component } from 'react';
import { ButtonGroup, CssBaseline, withStyles } from '@material-ui/core';
import axios from 'axios';
import './Program.css';
import { EVENT_ID, EVENT_NAME, EVENTS_API_URL, PROGRAM_API_URL } from '../constants';
// import TableContainer from '@material-ui/core/TableContainer';
// import Table from '@material-ui/core/Table';
// import TableHead from '@material-ui/core/TableHead';
// import TableRow from '@material-ui/core/TableRow';
// import TableBody from '@material-ui/core/TableBody';
// import TableCell from '@material-ui/core/TableCell';
import Button from '@material-ui/core/Button';
import ProgramDetailDialog from './ProgramDetailDialog';
import PgmVodDialog from '../components/dialogs/PgmVodDialog';
import Scheduler from './Scheduler';
// import { BsSquareFill } from 'react-icons/bs';

const moment = require('moment');

const styles = (theme) => ({
  table: {
    marginTop: '10px',
    overflowX: 'hidden',
  },
  dateButton: {
    textTransform: 'none',
    fontSize: 'large',
  },
});
// const StyledTableCell = withStyles((theme) => ({
//   head: {
//     backgroundColor: theme.palette.primary.bg,
//     color: theme.palette.primary.point,
//     fontWeight: 'bold !important',
//     textAlign: 'center',
//     [theme.breakpoints.down('sm')]: {
//       fontSize: 10,
//     },
//     '&:not(:first-child)': {
//       borderLeft: '1px solid ',
//       borderBottom: '0px',
//       borderColor: 'white',
//       width: '5%',
//     },
//   },
//   body: {
//     fontSize: 14,
//     textAlign: 'center',
//     [theme.breakpoints.down('sm')]: {
//       fontSize: 10,
//     },
//     '&:not(:first-child)': {
//       borderLeft: '1px solid ',
//       borderColor: theme.palette.primary.bg,
//     },
//   },
// }))(TableCell);

// const StyledTableRow = withStyles((theme) => ({
//   root: {
//     '& td': {
//       // width: '48%',
//     },
//     '& th:first-child': {
//       width: '7%',
//       verticalAlign: 'top',
//       padding: '0px 16px',
//       fontSize: '0.8em',
//     },
//     '&:nth-of-type(odd)': {
//       // backgroundColor: theme.palette.action.hover,
//     },
//     '&.isBreak': {
//       backgroundColor: theme.palette.action.hover,
//       '& th, td': {
//         paddingTop: '4px',
//         paddingBottom: '4px',
//       },
//       '& th:first-child': {
//         verticalAlign: 'top',
//         padding: '0px 16px',
//         fontSize: '0.8em',
//       },
//     },
//     '&.isLive': {
//       backgroundColor: theme.palette.error,
//     },
//   },
// }))(TableRow);

// const pgmBrief = [
//   { day: '1st Day', title: 'Imaging & Physiology', announcer: 'Announcer: Yong-Joon Lee+Oh-Hyun Lee' },
//   { day: '2nd Day', title: 'Structural Cardiac Intervention', announcer: 'Announcer: Yong-Joon Lee+Oh-Hyun Lee' },
// ];
class ProgramDynamic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      arrDate: [],
      rows: [],
      selectDate: moment().format('YYYYMMDD'),
      programDetailDialog: false,
      pgmVodDialog: false,
      detail: [],
      pgmBriefIdx: this.props.value.dayIndex,
    };
  }

  componentDidMount() {
    this.init(this.props.value.dayIndex);
  }

  init = (idx) => {
    let _date = moment().format('YYYYMMDD');
    let item = JSON.parse(sessionStorage.getItem('Item'));
    if (this.props.value && this.props.value.arrDate && this.props.value.arrDate[idx])
      _date = moment(this.props.value.arrDate[idx]).format('YYYYMMDD');
    else _date = moment(item.startDate).format('YYYYMMDD');
    this.setState({ selectDate: _date, selectIdx: idx });

    axios
      .get(`${EVENTS_API_URL}/event/pgmByDate?eventId=${EVENT_ID}&date=${_date}`, { headers: { Pragma: 'no-cache' } })
      .then((response) => {
        console.log('PROGRAM AT A GLANCE :: API CALL', response.data.Items.length);
        let buff = response.data.Items;
        buff.sort((a, b) => {
          if (a.startTime > b.startTime) return 1;
          if (a.startTime < b.startTime) return -1;
          if (a.channel > b.channel) return 1;
          if (a.channel < b.channel) return -1;
          return 0;
        });
        //pgDate - 날짜, startTime, endTime
        for (let i = 0; i < buff.length; i++) {
          buff[i]['startDate'] = new Date(
            Number(buff[i].pgDate.substr(0, 4)),
            Number(buff[i].pgDate.substr(4, 2)) - 1,
            Number(buff[i].pgDate.substr(6, 2)),
            Number(buff[i].startTime.split(':')[0]),
            Number(buff[i].startTime.split(':')[1]),
          );
          buff[i]['endDate'] = new Date(
            Number(buff[i].pgDate.substr(0, 4)),
            Number(buff[i].pgDate.substr(4, 2)) - 1,
            Number(buff[i].pgDate.substr(6, 2)),
            Number(buff[i].endTime.split(':')[0]),
            Number(buff[i].endTime.split(':')[1]),
          );
          buff[i]['location'] = buff[i].channel;
          buff[i]['title'] = buff[i].pgTitle;
          buff[i]['priorityId'] = Number(buff[i].channel.substr(7, 2));

          let liveTF = false;

          for (let j = 0; j < this.props.value.arrCurrentSesseion.length; j++) {
            if (this.props.value.arrCurrentSesseion[j].id === buff[i].id) {
              liveTF = true;
              break;
            }
          }
          buff[i]['isLive'] = liveTF;
        }
        this.setState({ pgmList: buff });
        this.getStartEndTime(buff);
      });
  };
  getStartEndTime = (data) => {
    // console.log(data);
    let startTimeTemp =
      Number(data[0].startTime.split(':')[1]) > 30
        ? Number(data[0].startTime.split(':')[0]) + 0.5
        : Number(data[0].startTime.split(':')[0]);
    let endTimeTemp = null;
    for (let i = 0; i < data.length; i++) {
      if (i === data.length - 1) {
        // console.log(this.state.pgmList[i].endTime);
        endTimeTemp =
          Number(data[i].endTime.split(':')[1]) > 30
            ? Number(data[i].endTime.split(':')[0]) + 1
            : Number(data[i].endTime.split(':')[0]) + 0.5;
      }
    }

    this.setState({ startTime: startTimeTemp });
    this.setState({ endTime: endTimeTemp });
  };

  showDetail = (e, data) => {
    // if (!row[1].isBreak) {
    //   const pgmId = row[1][`${cn}_id`];
    //   const pgTitle = row[1][`${cn}`];
    //   const ch = `${cn}`;
    //   const selData = {
    //     pgTitle: pgTitle,
    //     ch: ch,
    //     pgmId: pgmId,
    //     dpTime: `${row[0]} - ${row[1].endTime}`,
    //   };
    //
    //   axios
    //     .get(`${PROGRAM_API_URL}/program/detail?eventId=${EVENT_ID}&pgmId=${pgmId}`, { headers: { Pragma: 'no-cache' } })
    //     .then((response) => {
    //       response.data.sort(function (a, b) {
    //         const ao = a.order ? Number(a.order) : 0;
    //         const bo = b.order ? Number(b.order) : 0;
    //         return ao < bo ? -1 : 0;
    //       });
    //       this.setState({ selData: selData, detail: response.data, programDetailDialog: true });
    //     });
    // }

    // console.log('showDetail', data);
    //KSIC2022 CUSTOM : Break 중에서 라이브, 디테일 클릭 가능하게
    // if (!data.isBreak) {
    if (!data.isBreak || data.id === 'pgm_1639563317220') {
      const pgmId = data.id;
      const pgTitle = data.title;
      const ch = data.channel;
      const selData = {
        pgTitle: pgTitle,
        ch: ch,
        pgmId: pgmId,
        pgSub: data.pgSub,
        dpTime: `${data.startTime} - ${data.endTime}`,
        isEng: data.isEng,
      };

      axios
        .get(`${PROGRAM_API_URL}/program/detail?eventId=${EVENT_ID}&pgmId=${pgmId}`, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          // response.data.sort(function (a, b) {
          //   const ao = a.order ? Number(a.order) : 0;
          //   const bo = b.order ? Number(b.order) : 0;
          //   return ao < bo ? -1 : 0;
          // });
          response.data.sort(function (a, b) {
            return a.title < b.title ? -1 : 0;
          });

          this.setState({ selData: selData, detail: response.data, programDetailDialog: true });
        });
    }
  };

  clickProgram = (e, ch) => {
    e.stopPropagation();
    let win = window.open(`/#/live?ch=${ch}`, 'liveWin');
    win.document.title = EVENT_NAME + ' - Live';

    if (window.name === 'liveWin') {
      win.location.reload();
    }
  };

  clickVOD = (e, vod) => {
    const testVideo = 'https://s3.ap-northeast-2.amazonaws.com/hemlibra.web-symposium.co.kr/static/media/test1.8ab528fa.mp4';
    e.stopPropagation();
    if (!vod || vod === undefined || vod === '') {
      this.setState({ vodId: testVideo, pgmVodDialog: true });
    } else {
      this.setState({ vodId: vod, pgmVodDialog: true });
    }
  };

  getDateButton = () => {
    return this.props.value.arrDate.map((data, idx) => {
      const val = moment(data).format('YYYYMMDD');
      return (
        <Button
          key={idx}
          className={this.props.classes.dateButton}
          onClick={() => {
            this.init(idx);
          }}
          variant={this.state.selectDate === val ? 'contained' : 'outlined'}
        >
          {moment(data).format('MMMM DD (ddd.)')}
        </Button>
      );
    });
  };

  render() {
    // const { classes } = this.props;

    return (
      <React.Fragment>
        <CssBaseline />
        <ButtonGroup color="primary" disableElevation aria-label="outlined primary button group" fullWidth>
          {this.props.value.arrDate && this.props.value.arrDate.length > 0 ? this.getDateButton() : null}
        </ButtonGroup>
        {/* <Grid container style={{ paddingTop: 10 }}>
          <Grid container justifyContent="flex-end" alignItems="center">
            <Typography>break time &nbsp;</Typography>
            <BsSquareFill style={{ color: '#EBEBEB' }} />
          </Grid>
        </Grid> */}
        <div style={{ marginTop: this.state.matches ? '2em' : '1em' }}>
          {this.state.pgmList && this.state.pgmList.length > 0 ? (
            <Scheduler
              key={'scheduler' + this.state.selectIdx}
              data={this.state.pgmList}
              startHour={8}
              endHour={18}
              clickDetail={this.showDetail}
              clickProgram={this.clickProgram}
              clickVOD={this.clickVOD}
              selectDate={this.state.selectDate}
              selectIdx={this.state.selectIdx}
            />
          ) : null}
        </div>
        {/* <TableContainer>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Time</StyledTableCell>
                {CHANNEL_DP.map((c, idx) => {
                  return (
                    <StyledTableCell key={'ch-' + idx} align="center">
                      {c}
                    </StyledTableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>{this.state.rows.length > 0 ? this.getCell() : null}</TableBody>
          </Table>
        </TableContainer> */}
        <ProgramDetailDialog
          selData={this.state.selData}
          data={this.state.detail}
          open={this.state.programDetailDialog}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ programDetailDialog: false });
            }
          }}
          // onClose={() => this.setState({ programDetailDialog: false })}
          // disableBackdrop={false}
        />
        <PgmVodDialog
          open={this.state.pgmVodDialog}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ pgmVodDialog: false });
            }
          }}
          // onClose={() => this.setState({ pgmVodDialog: false })}
          // disableBackdrop={false}
          vodId={this.state.vodId}
        />
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ProgramDynamic);
